import React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Container,
} from "@mui/material";

const UserExperienceSection = () => {
  const userExperienceData = {
    title: "Forging Exceptional User Experience",
    description:
      "Every web service is a unique solution that has been carefully customized to meet the unique needs of a particular business. It frequently combines features from two to three distinct service categories. Although the features and layout of web services are discussed on an individual basis, several essential characteristics are always outlined in the functional and non-functional requirements. The user experience is greatly influenced by these characteristics.",
    cards: [
      {
        title: "Reliable & Secure",
        points: [
          "We grow with you, handling more users and data.",
          "Lightning-fast performance for quick access.",
          "We follow the rules – like HIPAA for your data security.",
          "We protect your info with encryption, always.",
        ],
        image: "/img/web/icon-1.png",
      },
      {
        title: "Engaging Experience",
        points: [
          "Our site adapts to your mobile. It's super user-friendly!",
          "Have fun with interactive tools like feedback forms and calculators.",
          "We personalize content based on your interests and what you've done here.",
          "Navigate the site effortlessly.",
        ],
        image: "/img/web/icon-2.png",
      },
    ],
  };

  return (
    <Box
      sx={{
        color: "white",
        textAlign: "center",
      }}
    >
      <Container>
        {/* Heading */}
        <Typography
          sx={{ fontWeight: "bold", mb: 2, color: "white", fontSize: "22px" }}
        >
          {userExperienceData.title}
        </Typography>
        <Box
          sx={{
            paddingLeft: { xs: "auto", md: "24px" },
            paddingRight: { xs: "auto", md: "24px" },
          }}
        >
          <Typography
            sx={{ margin: "auto", mb: 4, color: "white", fontSize: "18px" }}
          >
            {userExperienceData.description}
          </Typography>
        </Box>

        {/* Grid Layout */}
        <Grid container spacing={3} justifyContent="center">
          {userExperienceData.cards.map((card, index) => (
            <Grid item xs={12} md={5} key={index}>
              <Card
                sx={{
                  background: "rgba(58, 71, 89, 0.7)" /* Adjust transparency */,
                  backdropFilter: "blur(10px)",
                  color: "white",
                  borderRadius: "12px",
                  padding: "10px",
                  textAlign: "left",
                  boxShadow: "0px 5px 15px rgba(0,0,0,0.3)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                  transition: "background 0.3s ease", // Smooth transition for background color change
                  "&:hover": {
                    background: "linear-gradient(135deg, #BEBFF4, #2D30AB)", // Gradient background on hover
                    "& img": {
                      transform: "scale(1.2)", // Scale image on card hover
                    },
                  },
                }}
              >
                <CardContent>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      mb: 1,
                      color: "white",
                      fontSize: "20px",
                    }}
                  >
                    {card.title}
                  </Typography>
                  <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                    {card.points.map((point, idx) => (
                      <li key={idx} style={{ fontSize: "16px" }}>
                        {point}
                      </li>
                    ))}
                  </ul>
                </CardContent>
                <Box sx={{ textAlign: "right", paddingRight: "15px", pb: 2 }}>
                  <img
                    src={card.image}
                    alt={card.title}
                    width={100}
                    height={100}
                    style={{
                      transition: "transform 0.3s ease-in-out",
                    }}
                    // onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                    // onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
                  />
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default UserExperienceSection;
